<div class="autoscroll-image-carousel">
  <div *ngIf="imageList.length > 0" class="splide" #splideRef>
    <div class="splide__track">
      <ul class="splide__list">
        <li *ngFor="let image of imageList" class="splide__slide">
          <img [src]="image.src"
          [alt]="image.alt"
          [class.grayscale]="grayscaleImages"
          [ngStyle]="{aspectRatio: image?.width / image?.height}" />
        </li>
      </ul>
    </div>
  </div>
</div>
